import type { TemplateProps } from "./types"
import { BaseTemplate } from "./BaseTemplate"

/** Modern Impact: clean, minimalist. Teal + slate. Sans-serif. Subtle shadows and gradients. */
export function ModernImpactTemplate(props: TemplateProps) {
  const primary = props.customizations.primary_color ?? "#0d9488"
  const secondary = props.customizations.secondary_color ?? "#64748b"

  return (
    <div
      className="font-sans antialiased"
      style={
        {
          "--primary-color": primary,
          "--secondary-color": secondary,
          fontFamily: props.customizations.font_family ?? "Inter, sans-serif",
        } as React.CSSProperties
      }
    >
      <BaseTemplate {...props} />
    </div>
  )
}
